import React from 'react'
import { FieldArray } from 'formik'

import { t } from 'translations'
import { Button as MerinioButton, Card } from 'ui'
import { Input, PhoneNumber } from 'components/Forms'

const UserEmergencyContactsForm = ({ disabled, emergencyContacts = [] }) => {
  return (
    <FieldArray
      name="emergencyContacts"
      render={arrayHelpers => (
        <div className="mb-3">
          <h5>{t('manager.users.form.EMERGENCY_CONTACTS.TITLE')}</h5>
          <small className="form-text text-muted">{t('manager.users.form.EMERGENCY_CONTACTS.SUMMARY')}</small>

          <Card className="bg-light">
            <div className="p-3">
              {emergencyContacts.length
                ? emergencyContacts.map((emergencyContact, index) => (
                    <React.Fragment key={index}>
                      <Input module="manager.users.form.EMERGENCY_CONTACTS" name={`emergencyContacts[${index}].name`} required translation="name" />
                      <Input module="manager.users.form.EMERGENCY_CONTACTS" name={`emergencyContacts[${index}].relation`} translation="relation" />
                      <PhoneNumber
                        module="manager.users.form.EMERGENCY_CONTACTS"
                        name={`emergencyContacts[${index}].phoneNumber`}
                        required
                        translation="phoneNumber"
                      />

                      {!disabled && (
                        <div style={{ marginTop: '32px' }}>
                          <MerinioButton type="button" color="secondary" onClick={() => arrayHelpers.remove(index)} outlined>
                            <i className="fas fa-trash" />
                          </MerinioButton>
                        </div>
                      )}

                      {!disabled || index !== emergencyContacts.length - 1 ? <hr /> : null}
                    </React.Fragment>
                  ))
                : null}

              {!disabled && (
                <MerinioButton type="button" color="secondary" onClick={() => arrayHelpers.push({ name: '', relation: '', phoneNumber: '' })} outlined>
                  <i className="fas fa-plus" />
                </MerinioButton>
              )}
            </div>
          </Card>
        </div>
      )}
    />
  )
}

export default UserEmergencyContactsForm
